import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { globalImportUrl } from '../core/request';
/**
 * Ride Offsets and Segments
 * Return all of a ride's offsets and segments.  This includes offsets for when the class portion of the video begins, all of the segments within the class portion, the end time for the class, and the total duration of the class. If enabled, also includes subsegments of the segment. During a live class this endpoint will return every event that has happened so far.  For example, in the middle of the class portion of a live ride, this endpoint will include class_start_offset and one or more segments in the response, but class_end_offset and video_end_offset will not be included in the response for the live ride. Optionally, can return scheduled segments as well if query param provided.
 * @param id The ride id
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @param showScheduledSegments whether or not to include scheduled_segments property
 * @returns RideTimelineResponse Successful response
 * @throws ApiError
 */

export var getRideTimeline = function getRideTimeline(api, id, acceptLanguage, showScheduledSegments) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/ride/".concat(id, "/timeline");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof showScheduledSegments !== 'undefined') {
    localVarQueryParameter['show_scheduled_segments'] = showScheduledSegments;
  }

  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};
/**
 * Ride Offsets and Segments for studio platforms
 * Return all of a ride's offsets and segments.  This includes offsets for when the class portion of the video begins, all of the segments within the class portion, the end time for the class, and the total duration of the class. If enabled, also includes subsegments of the segment. During a live class this endpoint will return every event that has happened so far.  For example, in the middle of the class portion of a live ride, this endpoint will include class_start_offset and one or more segments in the response, but class_end_offset and video_end_offset will not be included in the response for the live ride. Optionally, can return scheduled segments as well if query param provided.
 * @param id The ride id
 * @param acceptLanguage Accept language(s) that the user choose on the device.
 * If not included or unsupported, the value will default to en-US.
 * Can be weighted with the quality value syntax.
 *
 * Examples:
 * Accept-Language: de
 * Accept-Language: en-US, en;q=0.5
 * Accept-Language: de-DE, de;q=0.9, en-US, en;q=0.7
 *
 * Specification: https://tools.ietf.org/html/rfc7231#section-5.3.5
 *
 * @param showScheduledSegments whether or not to include scheduled_segments property
 * @returns RideTimelineResponse Successful response
 * @throws ApiError
 */

export var getStudioRideTimeline = function getStudioRideTimeline(api, id, acceptLanguage, showScheduledSegments) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var localVarPath = "/api/studio/ride/".concat(id, "/timeline");
  var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
  var baseOptions;

  if (api.configuration) {
    baseOptions = api.configuration.baseOptions;
  }

  var localVarRequestOptions = _objectSpread(_objectSpread({
    method: 'GET'
  }, baseOptions), options);

  var localVarHeaderParameter = {};
  var localVarQueryParameter = {};

  if (typeof showScheduledSegments !== 'undefined') {
    localVarQueryParameter['show_scheduled_segments'] = showScheduledSegments;
  }

  localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
  localVarUrlObj.query = _objectSpread(_objectSpread(_objectSpread({}, localVarUrlObj.query), localVarQueryParameter), options.query); // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943

  delete localVarUrlObj.search;
  localVarRequestOptions.headers = _objectSpread(_objectSpread({}, localVarHeaderParameter), options.headers);
  var localVarAxiosArgs = {
    url: globalImportUrl.format(localVarUrlObj),
    options: localVarRequestOptions
  };
  var axios = api.axios;

  var axiosRequestArgs = _objectSpread(_objectSpread({}, localVarAxiosArgs.options), {}, {
    url: localVarAxiosArgs.url
  });

  return axios.request(axiosRequestArgs);
};